import React from 'react';
import { Chip, IconButton, Skeleton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getTemperatureIcon } from './temperature';

const TemperatureChip = ({
  hasInsight,
  temperature,
  temperatureValue,
  temperatureColor,
  iconOnly = false,
}) => {
  const { t } = useTranslation();

  if (!hasInsight) {
    return iconOnly
      ? <Skeleton variant="circular" width={40} height={40} />
      : <Skeleton variant="rounded" width={64} height={24} />;
  }

  const icon = getTemperatureIcon(temperatureValue, iconOnly ? 'medium' : 'small');

  if (iconOnly) {
    return (
      <Tooltip title={`${t('leads.filters.temperature')}: ${temperature}`}>
        <IconButton
          sx={(theme) => ({ color: theme.palette[temperatureColor]?.main })}
        >
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Chip
      label={temperature}
      icon={icon}
      color={temperatureColor}
      variant="outlined"
      size="small"
    />
  );
};

export default TemperatureChip;
